// A temporary main-only snapshot holds the outgoing content during the fade.
// It is inert and never initializes scripts or widgets.
export function snapshotPage() {
    const source = document.querySelector('#main-content');
    const bounds = source.getBoundingClientRect();
    const snapshot = source.cloneNode(true);
    const layer = document.createElement('div');
    layer.className = `page-motion-snapshot ${document.body.className}`;
    layer.setAttribute('aria-hidden', 'true');
    layer.inert = true;
    Object.assign(layer.style, {left: `${bounds.left}px`, top: `${bounds.top}px`, width: `${bounds.width}px`, height: `${bounds.height}px`});
    Object.assign(snapshot.style, {width: `${bounds.width}px`, minHeight: `${bounds.height}px`, margin: '0', background: 'var(--color-bg)'});
    const mediaSelector = 'iframe, object, embed, audio, video';
    const media = source.querySelectorAll(mediaSelector);
    snapshot.querySelectorAll(mediaSelector).forEach((node, index) => {
        const original = media[index], rect = original.getBoundingClientRect();
        const placeholder = document.createElement('div');
        placeholder.style.cssText = `width:${rect.width}px;height:${rect.height}px;max-width:100%;overflow:hidden`;
        if (original.poster) {
            const image = document.createElement('img');
            image.src = original.poster;
            image.style.cssText = 'width:100%;height:100%;object-fit:contain';
            placeholder.append(image);
        }
        node.replaceWith(placeholder);
    });
    snapshot.querySelectorAll('script').forEach(node => node.remove());
    // Even a late initial Ghost card bundle must not initialize a visual clone.
    const cardSelector = '.kg-audio-card, .kg-video-card, .kg-toggle-card, .kg-gallery-image';
    const cards = source.querySelectorAll(cardSelector);
    snapshot.querySelectorAll(cardSelector).forEach((node, index) => {
        const original = cards[index], style = getComputedStyle(original);
        for (const property of ['display', 'width', 'height', 'padding', 'margin', 'border', 'border-radius', 'background', 'color', 'flex', 'box-sizing']) {
            node.style.setProperty(property, style.getPropertyValue(property));
        }
        node.classList.remove('kg-audio-card', 'kg-video-card', 'kg-toggle-card', 'kg-gallery-image');
    });
    snapshot.querySelectorAll('form').forEach(form => {
        const container = document.createElement('div');
        container.className = form.className;
        container.append(...form.childNodes);
        form.replaceWith(container);
    });
    snapshot.querySelectorAll('input, textarea, select, button').forEach(control => {
        const placeholder = document.createElement('span');
        placeholder.className = control.className;
        placeholder.textContent = control.value || control.textContent || control.placeholder || '';
        placeholder.hidden = control.hidden;
        control.replaceWith(placeholder);
    });
    snapshot.querySelectorAll('[name], [autofocus], [contenteditable]').forEach(node => {
        node.removeAttribute('name'); node.removeAttribute('autofocus'); node.removeAttribute('contenteditable');
    });
    snapshot.removeAttribute('id');
    snapshot.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
    layer.append(snapshot);
    document.body.append(layer);
    snapshot.querySelectorAll('*').forEach(node => {
        // Match scrollable regions directly: removed script/id nodes do not
        // change the rendered widgets' own data attributes.
        if (node.matches('[data-bookmark-viewport], .bookmark-viewport, [data-activity-viewport]')) {
            const selector = node.matches('[data-activity-viewport]') ? '[data-activity-viewport]' : '[data-bookmark-viewport], .bookmark-viewport';
            const original = source.querySelector(selector);
            node.scrollTop = original.scrollTop; node.scrollLeft = original.scrollLeft;
        }
    });
    return layer;
}

export async function revealPage(layer, main) {
    const oldLeft = parseFloat(layer.style.left), oldTop = parseFloat(layer.style.top);
    const bounds = main.getBoundingClientRect();
    // Keep the outgoing pixels at their original viewport coordinates, even
    // when the incoming page restores a different reading position or height.
    layer.firstElementChild.style.transform = `translate(${oldLeft - bounds.left}px, ${oldTop - bounds.top}px)`;
    Object.assign(layer.style, {left: `${bounds.left}px`, top: `${bounds.top}px`, width: `${bounds.width}px`, height: `${bounds.height}px`});
    const outgoing = layer.animate([{opacity: 1}, {opacity: 0}], {duration: 80, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'});
    const incoming = main.animate([{opacity: 0, transform: 'translateY(12px)'}, {opacity: 1, transform: 'translateY(0)'}], {
        duration: 300, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'
    });
    main.classList.remove('page-motion-enter');
    try { await Promise.all([outgoing.finished, incoming.finished]); }
    finally { outgoing.cancel(); incoming.cancel(); layer.remove(); }
}
